// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".420119665b05a41fffb18959e7ab37f896097ca9.chunk.bundle.js";
};